import { AuditLogDetailHelper } from '../../Utils/AuditLogDetailHelper'

export class DetailPage {
    constructor(item: any) {
        var detail = AuditLogDetailHelper.renderDetailRow(item);
        var detailElement = document.getElementById("detailRow");
        detailElement.innerHTML = detail;
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/AuditLog/DetailPage.ts
 **/